<template>
 <div class="resource">
  <CompanyProfile v-if="path === 'companyProfile'"></CompanyProfile>
  <ServiceNetwork v-if="path === 'serviceNetwork'"></ServiceNetwork>
  <CooperationMode v-if="path === 'cooperationMode'"></CooperationMode>
 </div>
</template>

<script setup>
import CompanyProfile from "./companyProfile/index.vue"
import ServiceNetwork from "./serviceNetwork/index.vue"
import CooperationMode from "./cooperationMode/index.vue"
import { computed } from 'vue'

import { useRoute } from 'vue-router'

const route = useRoute()

const path = computed(() => route.query.id)

</script>

<style scoped lang="less">
.resource {
 width: 100%;
 height: 100%;
}
</style>